import PasswordForgotten from './PasswordForgotten'

export {
  PasswordForgotten
}


// WEBPACK FOOTER //
// ./src/screens/PasswordForgotten/index.js